import styledWithTheme, { css } from 'foundations-theming/utils';

export const BaseContainer = styledWithTheme.div<{ $svgSize?: string }>`
  display: flex;
  inline-size: 100%;
  aspect-ratio: 1 / 1;
  justify-content: center;
  align-items: center;

  ${({ $svgSize }) =>
    $svgSize &&
    css`
      svg {
        inline-size: ${$svgSize} !important;
        block-size: ${$svgSize} !important;
      }
    `}
`;
